// generated by the plop

import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AccessState, AccessStateModel, ProfileState, ProfileStateModel, UserModel } from 'shared';
import { PermissionEnum } from 'symbols';
import { TALON_ACCESS_STATE_DEFAULT, TalonAccessStateModel } from './talon-access.model';

@State({ name: 'TalonAccess', defaults: TALON_ACCESS_STATE_DEFAULT })
@Injectable()
export class TalonAccessState {


  /**
   * Generate configs for classroom module depends on a provided user role.
   */
  static generateTalonsAccess(roles: PermissionEnum[], user: UserModel): TalonAccessStateModel {
    // Return permissions as for an unknown role if user not verified or not authenticated.
    if (!user) {
      return this.generateRoleConfig(PermissionEnum.UNKNOWN);
    }

    // Apply permissions of each provided role.
    const rolesConfig: TalonAccessStateModel[] = roles.map(role => this.generateRoleConfig(role));

    // Return defined config.
    return this.mergeConfig(rolesConfig);
  }

  /**
   * Define and create config using provided config data.
   */
  static generateRoleConfig(role: PermissionEnum): TalonAccessStateModel {
    switch (role) {
      case PermissionEnum.CAN_SAVE_FORCE:
        return {
          ...TALON_ACCESS_STATE_DEFAULT,
          canSaveForce: true
        };
      case PermissionEnum.CAN_READ_TALONS_BY_ID:
        return {
          ...TALON_ACCESS_STATE_DEFAULT,
          canReadTalonById: true
        };
      case PermissionEnum.CAN_READ_TALONS:
        return {
          ...TALON_ACCESS_STATE_DEFAULT,
          canReadTalon: true
        };
      case PermissionEnum.CAN_WRITE_TALONS:
        return {
          ...TALON_ACCESS_STATE_DEFAULT,
          canWriteTalons: true
        };
      case PermissionEnum.CAN_READ_DEBTS:
        return {
          ...TALON_ACCESS_STATE_DEFAULT,
          canReadDebts: true
        };
      case PermissionEnum.CAN_WRITE_DEBTS:
        return {
          ...TALON_ACCESS_STATE_DEFAULT,
          canWriteDebts: true
        };
      case PermissionEnum.CAN_READ_RECEIPT_OF_TALON:
        return {
          ...TALON_ACCESS_STATE_DEFAULT,
          canReadReceiptOfTalon: true
        };
      case PermissionEnum.CAN_WRITE_RECEIPT_OF_TALON:
        return {
          ...TALON_ACCESS_STATE_DEFAULT,
          canWriteReceiptOfTalon: true
        };
      case PermissionEnum.SUPER_USER:
        return {
          canReadTalon: true,
          canRemoveTemplate: true,
          canWriteReceiptOfTalon: true,
          canReadReceiptOfTalon: true,
          canReadDebts: true,
          canSaveForce: true,
          canWriteDebts: true,
          canWriteTalons: true,
          canReadTalonById: true
        };
      default: {
        return {
          ...TALON_ACCESS_STATE_DEFAULT
        };
      }
    }
  }

  /**
   * Merge provided roles configs (by union rule).
   */
  static mergeConfig(rolesConfig: TalonAccessStateModel[]): TalonAccessStateModel {
    const moduleConfig: TalonAccessStateModel = TALON_ACCESS_STATE_DEFAULT;

    for (const config of rolesConfig) {
      moduleConfig.canReadTalon = moduleConfig.canReadTalon ? true : config.canReadTalon;
      moduleConfig.canReadDebts = moduleConfig.canReadDebts ? true : config.canReadDebts;
      moduleConfig.canReadTalonById = moduleConfig.canReadTalonById ? true : config.canReadTalonById;
      moduleConfig.canSaveForce = moduleConfig.canSaveForce ? true : config.canSaveForce;
      moduleConfig.canWriteTalons = moduleConfig.canWriteTalons ? true : config.canWriteTalons;
      moduleConfig.canWriteDebts = moduleConfig.canWriteDebts ? true : config.canWriteDebts;
      moduleConfig.canReadReceiptOfTalon = moduleConfig.canReadReceiptOfTalon ? true : config.canReadReceiptOfTalon;
      moduleConfig.canWriteReceiptOfTalon = moduleConfig.canWriteReceiptOfTalon ? true : config.canWriteReceiptOfTalon;
      moduleConfig.canRemoveTemplate = moduleConfig.canRemoveTemplate ? true : config.canRemoveTemplate;
    }

    return moduleConfig;
  }

  /**
   * Define and create module access rules using provided portal data.
   */
  @Selector([ProfileState, AccessState])
  static accessToTalons(profileState: ProfileStateModel, accessState: AccessStateModel): TalonAccessStateModel {
    const userData = profileState.currentUser;
    const roleList = accessState.roles;

    return TalonAccessState.generateTalonsAccess(roleList, userData);
  }
}


